// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.vault.Vault

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface VaultData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "Vault";
    id: string;
    name: string;
    engine: string;
    keys: string[];
}

export class VaultStore {
    readonly _entity_class_name = "Vault" as const;
    id: string;
    name: string;
    engine: string;
    keys: string[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: VaultData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.engine = wrapEntity(data.engine, transport, [...chainPath, "engine"]);
        this.keys = wrapEntity(data.keys, transport, [...chainPath, "keys"]);
        makeObservable(this, {
            id: observable,
            name: observable,
            engine: observable,
            keys: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async get_vault_engine(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_vault_engine", [], {});
    }

    async update_settings(name: any, engine: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "update_settings", [name, engine], {});
    }

    async set_key(key: any, value: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "set_key", [key, value], {});
    }

    async delete_key(key: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "delete_key", [key], {});
    }

    async resolve(requirements: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "resolve", [requirements], {});
    }
}

registerEntity("Vault", VaultStore);
